const Condition = Object.freeze({
    NEW: 'NEW',
    WORN: 'WORN',
    REPAIRABLE: 'REPAIRABLE',
    NOT_REPAIRABLE: 'NOT_REPAIRABLE',
    DAMAGED: 'DAMAGED'
});

export {Condition};